<script lang="ts" setup>
export interface SearchAutocompleteButtonSubmitProps {
    type: 'submit' | 'button'
    label: string
}
const props = defineProps<SearchAutocompleteButtonSubmitProps>()
</script>
<template>
  <!-- Accessibility: aria-label on button for screen readers (WCAG 4.1.2) -->
  <button
    :type="props.type"
    :aria-label="props.label"
    class="search-submit border-0 p-0 m-0 d-block"
  >
    <svg
      aria-hidden="true"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      class="d-block pe-none"
    >
      <path
        d="M8.23413,16.46829c2.00732,0 3.84729,-0.7244 5.27759,-1.92195l4.92688,4.92683c0.14282,0.14293 0.3302,0.21414 0.5614,0.21414c0.14294,0 0.3302,-0.07121 0.47314,-0.21414c0.28589,-0.28586 0.28589,-0.74879 0,-1.03464l-4.92676,-4.92683c1.198,-1.43025 1.92188,-3.27026 1.92188,-5.27757c0,-4.54048 -3.6936,-8.23415 -8.23413,-8.23415c-4.54053,0 -8.23413,3.69366 -8.23413,8.23415c0,4.54001 3.6936,8.23415 8.23413,8.23415M8.23413,1.46341c3.76587,0 6.76587,3.03756 6.76587,6.77073c0,3.76586 -3,6.76586 -6.76587,6.76586c-3.73315,0 -6.77075,-3 -6.77075,-6.76586c0,-3.73317 3.0376,-6.77073 6.77075,-6.77073"
      />
    </svg>
  </button>
</template>
